
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|338|6014|6716)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
